// ChartOfAccounts.ts
import {COAAccountType} from "./coa-account-type.model";

export class ChartOfAccounts {

    accountId: number;
    accountCode: string;
    accountName: string;
    accountType: COAAccountType;
    parentAccount: ChartOfAccounts | null;
    isActive: boolean;
    allowReconciliation: boolean;
    owningCompanyId: number | null;
    internalType: string | null;
    allowEditing: boolean | null;
    deprecated: boolean;
    currencyCode?: string | null;
    currentBalance?: number | null;
    childrenAccounts?: ChartOfAccounts[] = [];

}
